import React from "react";
import "../CSS/Layouts/Connect.css";
import Seo from "../components/Seo.js";

function UnderMaintenance() {
  const maintenanceHeading = "Page Under Maintenance";

  return (
    <main id="connect-content">
      <Seo
        title={maintenanceHeading}
        description="This page is temporarily under maintenance. Visit Yusef Agency for creative branding, commercial content, and event campaigns that help brands grow revenue."
        path="/comingsoon"
        noindex={true}
      />
      <div className="connect-cta">
        <h1 className="connect-title">
          <a href="/" style={{fontSize:"3rem", fontFamily:"nougat-script", textDecoration: 'none', color: 'white' }}>
            {maintenanceHeading}...
          </a>
        </h1>
      </div>       
    </main>
  );
}

export default UnderMaintenance;
 